import { render, staticRenderFns } from "./FollowIcon.vue?vue&type=template&id=0c66de3a&"
import script from "./FollowIcon.vue?vue&type=script&lang=js&"
export * from "./FollowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports